import React, { useState } from "react";
import ResidentialBuildingBhangal from "../images/residentialBuildingBhangal.jpeg"
import ResidentialBuildingGoldhunga from "../images/residentialBuildingGoldhunga.jpeg"
import ResidentialBuildingKavresthali from "../images/residentialBuildingKavresthali.jpeg"
import InteriorDesignUttadhoka from "../images/interiorDesginUttardhoka.jpeg"
import InteriorDesignPanipokhari from "../images/interiorWorksPanipokhari.jpeg"
import DonfengCSJorpati from "../images/dongengWorshopEvJorpati.jpeg"
import DongfengCS from "../images/dongfengChargingStation.jpeg"
import BaristaClass from "../images/bristaClassSukhedhara.jpeg"
import "../styles/gallery.css";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap Import
import { Link } from "react-router";


const Gallery = () => {
  const images = [ResidentialBuildingBhangal,ResidentialBuildingGoldhunga,ResidentialBuildingKavresthali,
                  InteriorDesignUttadhoka,InteriorDesignPanipokhari,DonfengCSJorpati,DongfengCS,BaristaClass];

  const [currentIndex, setCurrentIndex] = useState(null);

  // Handlers
  const openImage = (index) => setCurrentIndex(index);

  const closeImage = () => setCurrentIndex(null);

  const showPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const showNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <div className="gallery-container container">
      {/* Bootstrap Grid */}
      <div className="row">
        {images.map((image, index) => (
          <div key={index} className="col-md-3 col-sm-6 mb-4 image-gallery">
            {/* Image */}
            <img
              src={image}
              alt={`Gallery ${index}`}
              className="grid-image img-fluid"
              onClick={() => openImage(index)}
              style={{
                cursor: "pointer",
                borderRadius: "5px",
                height: "200px",
                objectFit: "cover",
                width: "100%",
              }}
            />
          </div>
        ))}
      </div>

      {/* Full-Screen Slider */}
      {currentIndex !== null && (
        <div className="slider-overlay">
          <button className="close-button" onClick={closeImage}>
            ×
          </button>
          <button className="slider-button-gallery prev" onClick={showPrevious}>
            ❮
          </button>
          <img
            src={images[currentIndex]}
            alt={`Slide ${currentIndex}`}
            className="slider-image"
          />
          <button className="slider-button-gallery next" onClick={showNext}>
            ❯
          </button>
        </div>
      )}
      <div className="button-projects">
      <Link to="/projects" className="button-all-projects">View All Projects</Link>
    </div>
    </div>
  );
};

export default Gallery;
